import jwt_decode from 'jwt-decode';
import { capitalize, find, flatMap, get, head, isEmpty, last, map, without } from 'lodash';
import { history } from 'main';
import Chip from 'material-ui/Chip';
import React from 'react';
import { connect } from 'react-redux';

import { login } from '../../routes/Login/modules/login';
import posService from '../../services/pos-service';
import classes from './CoreLayout.scss';

function getPosTokenInfo() {
  let savedToken = sessionStorage.getItem('posUserToken');
  if (!savedToken) return undefined;
  try {
    let decoded = jwt_decode(savedToken);
    return {
      businessUnitId: get(decoded, 'businessUnit'),
      tenantId: get(decoded, 'tenantId'),
    };
  } catch (err) {
    return undefined;
  }
}

const MenuConfig = [
  {
    title: "Products",
    menus: [
      {
        title: "Overall summary",
        route: "/overall-summary",
      },
      {
        title: "Store Sales",
        route: "/detailed-analytics",
      },
      {
        title: "Product Sales",
        route: "/product-wise-sales-analytics",
      },
      {
        title: "Frequency Analysis",
        route: "/product-analytics/frequency-analysis",
      },
      {
        title: "Basket Analysis",
        route: "/basket-analysis",
      },
      {
        title: "Sales Forecast",
        route: "/product-sales-forecast",
      },
    ],
  },
  {
    title: "Customer Analysis",
    menus: [
      {
        title: "Lifecycle Management",
        route: "/purchases-clustering-analytics",
      },
      {
        title: "Feedback Analysis",
        route: "/form-response-analytics",
      },
      {
        title: "Frequency Analysis",
        route: "/customer-purchase",
      },
    ],
  },
  {
    title: "Store Operations",
    menus: [
      {
        title: "Merchandize Sales",
        route: "/category-analytics",
      },
      {
        title: "Store Sales Comparison",
        route: "/detailed-analytics",
      },
    ],
  },
  {
    title: "Campaign Analysis",
    menus: [
      {
        title: "Campaign Sales",
        route: "/sales-analytics",
      },
      {
        title: "Campaign Details",
        route: "/campaign-details-v2",
      },
    ],
  },
];

const handleSettingIcon = (e) => {
  history.push("/general-setting");
};

export class CoreLayout extends React.Component {
  constructor(props, prevProps) {
    super(props);
    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  static defaultProps = {
    appName: "CASA",
  };

  state = {
    open: false,
  };

  toggleDrawer() {
    this.setState({ open: !this.state.open });
  }

  logRenderedUrl() {
    let posTokenInfo = getPosTokenInfo();
    if (!posTokenInfo || !posTokenInfo.tenantId) return;
    posService
      .logRenderedUrl(window.location.href, posTokenInfo.businessUnitId, posTokenInfo.tenantId)
      .catch(() => {});
  }

  componentDidMount() {
    this.logRenderedUrl();
  }

  componentDidUpdate(prevProps) {
    if (get(prevProps, "location.pathname") !== get(this.props, "location.pathname")) {
      this.logRenderedUrl();
    }
  }

  getRoutePath() {
    return get(this.getMenuItemDetails(), "showTopMenu")
      ? ""
      : get(this.props, "location.pathname");
  }

  menuRedirect(route, menuState) {
    this.setState({ currentMenuItemRoute: route });
    this.setState(menuState);
    history.push(route);
  }

  renderDrawer() {
    return (
      // <Drawer
      //   open={this.state.open}
      //   docked={false}
      //   onRequestChange={this.toggleDrawer}
      // >
      //   <SideBarList
      //     currentUser={get(this.props, "loginState.user")}
      //     onClick={this.toggleDrawer}
      //   />
      // </Drawer>
      null
    );
  }

  getMenuItemDetails() {
    // Need to refactor
    let path = get(this.props, "location.pathname");
    let topMenuItem = find(
      flatMap(MenuConfig, (menu) => menu.menus),
      { route: path }
    );
    let isFromTopMenuItem = false;
    let selectedSubMenu = MenuConfig[0].menus[0];
    if (topMenuItem) {
      isFromTopMenuItem = true;
      selectedSubMenu = topMenuItem;
    }
    let selectedMainMenuName = without(
      map(MenuConfig, (t) => {
        return !isEmpty(find(t.menus, { route: path })) ? t.title : "";
      }),
      ""
    );
    let selectedMainMenu = find(MenuConfig, {
      title: selectedMainMenuName[0],
    });
    let mainMenu = isEmpty(selectedMainMenu)
      ? head(MenuConfig)
      : selectedMainMenu;
    return {
      showTopMenu: isFromTopMenuItem,
      selectedMenu: mainMenu,
      selectedSubMenu: selectedSubMenu,
    };
  }

  render() {
    const searchParams = new URLSearchParams(location.search);
    const isUserSpecific =
      (searchParams.has("token") && searchParams.has("loadTokenFromUrl")) ||
      false;
    const shouldShowDrawer = this.props.location.pathname !== "/login";
    const drawerComponent =
      !isUserSpecific && shouldShowDrawer && this.renderDrawer();
    let currentRoute = last(this.props.routes);
    if (get(currentRoute, "isPrintView")) {
      return <div className={classes.container}>{this.props.children}</div>;
    } else {
      let loginState = this.props.loginState || { isLoggedIn: false };
      if (!loginState.isLoggedIn && Boolean(this.props.route.keycloak.token)) {
        this.props.login({});
      }
      let appBarRight = loginState.isLoggedIn ? (
        <Chip>{loginState.user.email}</Chip>
      ) : (
        <span />
      );
      let content = (
        <div style={{ backgroundColor: "#F8F8F8" }}>{this.props.children}</div>
      );
      let nameIcon = loginState.isLoggedIn
        ? capitalize(loginState.user.email.substr(0, 1))
        : "C";

      const handleClick = () => {
        drawerComponent && history.push("/overall-summary");
      };
      return (
        <div className={classes.container}>
          <div className={classes.headerContainer}>
            <div onClick={handleClick}>
              <img
                src="/icons/casa-icon.svg"
                style={{ height: 24, cursor: "pointer" }}
              ></img>
            </div>
            {/* <Menus
              showTopMenu={get(this.getMenuItemDetails(), "showTopMenu")}
              menuItems={MenuConfig}
              selectedMenu={get(this.getMenuItemDetails(), "selectedMenu")}
              selectedSubMenu={get(
                this.getMenuItemDetails(),
                "selectedSubMenu"
              )}
              routePath={this.getRoutePath()}
              onChangeMenu={(route, menuState) =>
                this.menuRedirect(route, menuState)
              }
            /> */}
           <div className={classes.user}>
           <span>{appBarRight}</span>
            <div className={`${classes.nameIcon}`}>
              <span className={classes.textStyle}>{nameIcon}</span>
            </div>
           </div>
            {/* <div style={{ height: "100%" }}>{drawerComponent}</div> */}
            {/* {!!drawerComponent && (
              <SettingsIcon
                className={classes.settingsIcon}
                onClick={handleSettingIcon}
              ></SettingsIcon>
            )} */}
          </div>
          {content}
        </div>
      );
    }
  }
}

CoreLayout.propTypes = {
  children: React.PropTypes.element.isRequired,
};

const mapActionCreators = {
  login,
};

const mapStateToProps = (state) => ({
  loginState: state.loginState,
});

export default connect(mapStateToProps, mapActionCreators)(CoreLayout);



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js